module.exports = __webpack_public_path__ + "img/sert_biboss_resize.29178bf6.png";